import { BiUser } from 'react-icons/bi';
import { CgShoppingCart, CgDollar } from 'react-icons/cg';
import { GoClock } from 'react-icons/go';

// Stats Card Data
export const getStatsData = () => [
  {
    type: 'clients',
    value: '27',
    progressValue: 25
  },
  {
    type: 'orders',
    value: '68',
    progressValue: 40
  },
  {
    type: 'tat',
    value: '312',
    progressValue: 60
  },
  {
    type: 'earnings',
    value: '127',
    progressValue: 80
  }
];

// Revenue Chart Data
export const getRevenueData = () => [
  { month: 'March', deliveries: 24000, earnings: 18000, pending: 27000, refunds: 9000 },
  { month: 'April', deliveries: 28000, earnings: 25000, pending: 22000, refunds: 11000 },
  { month: 'May', deliveries: 32000, earnings: 30000, pending: 20000, refunds: 13000 },
  { month: 'June', deliveries: 28000, earnings: 10000, pending: 30000, refunds: 12000 },
  { month: 'July', deliveries: 35000, earnings: 40000, pending: 20000, refunds: 25000 },
  { month: 'August', deliveries: 45000, earnings: 20000, pending: 15000, refunds: 15000 },
  { month: 'September', deliveries: 38000, earnings: 48000, pending: 25000, refunds: 10000 }
];

// Orders Overview Chart Data
export const getOrdersData = () => [
  { month: 'March', delivered: 25000, fresh: 32000, onhold: 14000, revisions: 18000 },
  { month: 'April', delivered: 30000, fresh: 34000, onhold: 13000, revisions: 20000 },
  { month: 'May', delivered: 33000, fresh: 37000, onhold: 12000, revisions: 15000 },
  { month: 'June', delivered: 28000, fresh: 40000, onhold: 15000, revisions: 30000 },
  { month: 'July', delivered: 35000, fresh: 30000, onhold: 12000, revisions: 16000 },
  { month: 'August', delivered: 45000, fresh: 35000, onhold: 16000, revisions: 17000 },
  { month: 'September', delivered: 38000, fresh: 38000, onhold: 11000, revisions: 12500 }
];

// Chart Categories - Fixed to match data properties
export const revenueCategories = ['Deliveries', 'Earnings', 'Pending', 'Refunds'];
export const ordersCategories = ['Delivered', 'Fresh', 'On Hold', 'Revisions'];

// Chart Colors
export const chartColors = {
  revenue: ['#0077b6', '#3fa34d', '#ffcb05', '#ef233c'],
  orders: ['#0077b6', '#3fa34d', '#ffcb05', '#ef233c']
};

// API Functions (for future use)
export const fetchDashboardStats = async () => {
  // This will be replaced with actual API call
  return getStatsData();
};

export const fetchRevenueData = async (dateRange) => {
  // This will be replaced with actual API call
  return getRevenueData();
};

export const fetchOrdersData = async (dateRange) => {
  // This will be replaced with actual API call
  return getOrdersData();
};

// Turnaround Time Data
export const getTurnaroundData = () => [
  {
    member: "Aarav Sharma",
    tasks: 5,
    time: "42 min"
  },
  {
    member: "Ishita Mehra",
    tasks: 3,
    time: "35 min"
  },
  {
    member: "Rohan Verma",
    tasks: 7,
    time: "1 hr 10 min"
  },
  {
    member: "Neha Kapoor",
    tasks: 2,
    time: "18 min"
  },
  {
    member: "Arjun Singh",
    tasks: 6,
    time: "55 min"
  },
  {
    member: "Kriti Malhotra",
    tasks: 4,
    time: "39 min"
  },
  {
    member: "Rahul Nair",
    tasks: 8,
    time: "1 hr 25 min"
  },
  {
    member: "Simran Kaur",
    tasks: 1,
    time: "12 min"
  },
  {
    member: "Dev Patel",
    tasks: 9,
    time: "1 hr 40 min"
  },
  {
    member: "Ananya Joshi",
    tasks: 5,
    time: "47 min"
  }
];

// Unread Messages Data
export const getUnreadMessages = () => [
  {
    sender: "Project Location",
    address: "Liggett Residence - 807 Sandy Bar Dr, Copperopolis, CA 95228",
    status: "Media message received",
    unreadCount: 5,
    time: "06:21 PM",
    date: "September 17, 2025"
  },
  {
    sender: "Site Inspection",
    address: "Maplewood Estates - 123 Elm St, Springfield, IL 62704",
    status: "Inspection completed",
    unreadCount: 2,
    time: "09:45 AM",
    date: "September 18, 2025"
  },
  {
    sender: "System Alert",
    address: "Automated Notification",
    status: "Battery low warning",
    unreadCount: 1,
    time: "12:10 PM",
    date: "September 19, 2025"
  },
  {
    sender: "New Lead",
    address: "Green Valley Homes - 456 Oak Dr, Denver, CO 80203",
    status: "Contact form submitted",
    unreadCount: 3,
    time: "02:30 PM",
    date: "September 20, 2025"
  },
  {
    sender: "Maintenance",
    address: "Sunnybrook Complex - 789 Pine Rd, Austin, TX 78701",
    status: "Filter replacement due",
    unreadCount: 4,
    time: "08:15 AM",
    date: "September 21, 2025"
  },
  {
    sender: "Customer Feedback",
    address: "Willow Creek - 321 Birch Ln, Seattle, WA 98101",
    status: "Service survey response",
    unreadCount: 0,
    time: "11:50 AM",
    date: "September 22, 2025"
  },
  {
    sender: "Invoice",
    address: "Oakridge Solar - 654 Cedar Ct, Portland, OR 97205",
    status: "Invoice #1024 ready",
    unreadCount: 1,
    time: "04:05 PM",
    date: "September 23, 2025"
  },
  {
    sender: "Support",
    address: "Helpdesk Ticket",
    status: "Ticket #458 responded",
    unreadCount: 2,
    time: "10:00 AM",
    date: "September 24, 2025"
  }
];
